import { createFileRoute } from '@tanstack/react-router'
import { SigningPage } from '../components/signatures/SigningPage'

// The signer's page (spec 2026-10-05-05 §3). Outside routes/$org, so it
// inherits no auth guard: the signer has no account, the link token in the
// URL fragment is the whole authorization.
export const Route = createFileRoute('/s/$orgCode')({
  component: SigningRoute,
})

function SigningRoute() {
  const { orgCode } = Route.useParams()
  return <SigningPage orgCode={orgCode} />
}
